(function () {
    'use strict';

    angular
        .module('directives.translate', [])
        .directive('translate', directive);

    directive.$inject = ['$rootScope'];

    function directive($rootScope) {
        return {
            scope: {
                params: '=translate',
                lang: '='
            },
            restrict: 'A',
            link: function (scope, element) {

                scope.$watchGroup(['lang', 'params'], function () {
                    updateText();
                });

                function updateText() {
                    if (!scope.params) return;
                    var lang = (scope.lang || $rootScope.currentLang || 'EN').toLocaleLowerCase();

                    var text = scope.params.default;

                    // No default
                    if (!text) {
                        text = scope.params[lang] || '';
                        element.text(text);
                        return;
                    }

                    if (lang === 'fr') {
                        text = _.isNil(scope.params.fr) ? text : scope.params.fr;
                    }

                    element.text(text);
                }
            }
        }
    }
})();
